import { getAllArtists, ArtistData } from '@/lib/artistData';

const artistAccent: Record<string, { active: string; activeText: string; activeBorder: string; activeShadow: string }> = {
  aimusicdreams: {
    active:       'bg-gradient-to-r from-amber-500 to-orange-500',
    activeText:   'text-white',
    activeBorder: 'border-amber-500/40',
    activeShadow: '0 8px 32px rgba(245,158,11,0.3)',
  },
  idreamz: {
    active:       'bg-gradient-to-r from-cyan-500 to-blue-500',
    activeText:   'text-white',
    activeBorder: 'border-cyan-500/40',
    activeShadow: '0 8px 32px rgba(6,182,212,0.3)',
  },
};

const fallbackAccent = {
  active:       'bg-gradient-to-r from-violet-500 to-purple-600',
  activeText:   'text-white',
  activeBorder: 'border-violet-500/40',
  activeShadow: '0 8px 32px rgba(167,84,255,0.3)',
};

interface ArtistSwitcherProps {
  currentArtist: string;
  onArtistChange: (artistId: string) => void;
}

const ArtistSwitcher = ({ currentArtist, onArtistChange }: ArtistSwitcherProps) => {
  const artists = getAllArtists();

  return (
    <div className="flex gap-3 sm:gap-4 justify-center mb-12 flex-wrap px-4">
      {artists.map((artist: ArtistData) => {
        const isActive = currentArtist === artist.id;
        const accent   = artistAccent[artist.id] ?? fallbackAccent;

        return (
          <button
            key={artist.id}
            onClick={() => onArtistChange(artist.id)}
            className={[
              'px-6 sm:px-8 py-3 rounded-2xl text-base sm:text-lg font-semibold transition-all duration-300 hover:scale-105 flex-1 sm:flex-none min-w-[130px] border',
              isActive
                ? `${accent.active} ${accent.activeText} ${accent.activeBorder}`
                : 'bg-white/10 text-white/70 border-white/20 hover:bg-white/20 hover:text-white',
            ].join(' ')}
            style={isActive ? { boxShadow: accent.activeShadow } : undefined}
          >
            {artist.displayName}
          </button>
        );
      })}
    </div>
  );
};

export default ArtistSwitcher;
